@if (dataLoaded()) {
  <div class="stu-public-activity-detail">
    <div class="pre-page">
      <h1 class="heading-text">
        <a (click)="onBack()"><i class="fa fa-chevron-left"></i></a>活動記録詳細
      </h1>
    </div>
    <div class="block-info">
      <div class="row">
        <div class="col-md-9 col-xs-9 block-time">
          <p>作成日時：{{ activityRecord?.created_at }}</p>
          @if (!!activityRecord?.updated_at) {
            <p>最終更新：{{ activityRecord?.updated_at | date: 'yyyy/MM/dd HH:mm' }}</p>
          }
          @if (activityRecord?.is_answer) {
            <p>［課題］</p>
          }
        </div>
      </div>
      <div>作成者： {{ activityRecord.user ? activityRecord.user.name : '匿名' }}</div>
      @for (pickup of activityRecord.pickups; track pickup.id) {
        <div>
          <app-pickup-item-toggle [pickup]="pickup" [pickupType]="'public_activity'"></app-pickup-item-toggle>
        </div>
      }
    </div>
    <app-document-detail-student
      [document]="activityRecord?.record"
      [categoryName]="activityRecord?.category_name"
      [workType]="activityRecord?.work_type"
      [marks]="activityRecord?.marks"
      [document_answers]="activityRecord.record.document_answers"
      [isCompassAnswer]="activityRecord?.is_compass_answer"
    >
    </app-document-detail-student>
    <div class="form-cross-assessment">
      @if (activityRecord.can_cross_review) {
        <app-cross-assessment-form
          [activityRecordId]="activityRecord?.id"
          [spaceId]="spaceId"
          (saveNewAssessment)="onSaveNewAssessment($event)"
        >
        </app-cross-assessment-form>
      }
    </div>
    @if (activityRecord.cross_assessments.length > 0) {
      <h2 class="assessments-header">みんなからのコメント</h2>
      @for (assessment of activityRecord.cross_assessments; track assessment.id; let isFirst = $first) {
        @switch (assessment !== edittingAssessment) {
          @case (true) {
            <div class="assessment-detail">
              <app-student-assessment-detail
                [assessment]="assessment"
                [canEdit]="canEditAssessment(assessment)"
                [isFirst]="isFirst"
                [onPublicActivity]="true"
                (editAssessment)="onEditAssessment(assessment)"
              >
              </app-student-assessment-detail>
            </div>
          }
          @case (false) {
            <div class="form-edit-cross-assessment">
              <app-cross-assessment-form
                [activityRecordId]="activityRecord?.id"
                [spaceId]="spaceId"
                [assessment]="assessment"
                (cancelEditAssessment)="onCancelEditAssessment()"
                (updateOldAssessment)="onUpdateOldAssessment($event, assessment)"
                (deleteOldAssessment)="onDeleteOldAssessment(assessment)"
              >
              </app-cross-assessment-form>
            </div>
          }
        }
      }
    }
    <div class="block-last">
      <button class="spen-mod-btn" (click)="onBack()">戻る</button>
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
